import { PureComponent, createRef } from "react";
import BasicHeaderComponent from "segments/desktop/header/layouts/components/basic-header/basic-header-component";
import Button from "segments/desktop/core-components/button/button";
import { SIGNUP_BUTTON_TYPE } from "segments/desktop/core-components/button/button-consts";
import { withAbTests } from "/contexts/ab-tests-context";
import SecondaryHeaderDesktopComponent from "segments/desktop/header/layouts/base-header/secondary-header/secondary-header-desktop/secondary-header-desktop-component";
import {
  getMiniSiteUnifiedDesktopLogo,
  shouldHideGeneralPricingInMinisite,
  shouldHideGeneralTemplatesInMinisite,
  getClusterDesktopLogo,
  getMiniSiteLinks
} from "client/services/cluster-config-service/cluster-config-service";
import HeaderMenus from "segments/desktop/header/layouts/base-header/base-header-desktop/header-menu";
import {
  PRICING_PAGE_LINK,
  CONTACT_US_FROM_HEADER_PAGE_LINK,
  CONSULT_WITH_US_FROM_HEADER_PAGE_LINK,
  LOGIN_PAGE_LINK,
  TEMPLATE_CENTER_PAGE_LINK
} from "constants/links";
import { withGenericConfig } from "/contexts/generic-config-context";

import { CSSTransitionGroup } from "react-transition-group-community-version";
import { HEADER_SUBMENU_OPENED, HEADER_SUBMENU_CLOSED } from "/constants/bigbrain-event-types";
import { DESKTOP_HEADER_BASE_CLASS_NAME } from "segments/desktop/header/layouts/base-header/base-header-service";
import {
  shouldRenderUniverseHeaderABTest,
  shouldSeeConsultWithUsAbTest
} from "services/ab-tests/acquisition-ab-test-service";
import { ENGLISH_LOCALE_ID } from "constants/localization";
import { DIALOG_DIRECTIONS } from "components/core/language-picker/language-picker-service";
import LanguagePickerComponent from "components/core/language-picker/language-picker-component";
import classnames from "classnames";
import SignupPopupScreenComponent from "components/core/signups/signup-popup/signup-popup-screen-component";
import { componentStyles } from "./base-header-desktop-component.scss";
import LinkItemWithMenuComponent from "./link-item-with-menu/link-item-with-menu-component";
import LinkItemComponent from "./link-item/link-item-component";
import {
  PRODUCT_MENU_ID,
  USE_CASES_MENU_ID,
  SectionsLinkWithMenuMenuComponentMapping,
  SectionsHeadersMenuItemsMapping
} from "../base-header-service";
import HeaderConstants from "../constants";
import UniverseHeader from "./universe-header/universe-header";

class BaseHeaderDesktopComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      openedMenuId: null,
      showSignupPopup: false
    };

    this.openProductMenu = this.openLinkMenu.bind(this, PRODUCT_MENU_ID);
    this.openUseCasesMenu = this.openLinkMenu.bind(this, USE_CASES_MENU_ID);
    this._scrollInfo = { scrollTopWhenStartedScrollingUp: 0, prevScrollTop: 0, scrollingDown: true };
    this._headerRef = createRef();
  }

  componentDidMount() {
    const { isSecondaryMenuNeeded } = this.props;
    if (isSecondaryMenuNeeded) {
      window.addEventListener("scroll", this.scrollListenerForSecondaryMenuUnification, {
        passive: true
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollListenerForSecondaryMenuUnification);
    this.removeClickOutsideEvent();
  }

  removeClickOutsideEvent = () => {
    window.removeEventListener("mousedown", this.handleClickOutsideMenu);
  };

  handleClickOutsideMenu = (event) => {
    if (this?._headerRef?.current && !this._headerRef.current.contains(event.target)) {
      this.closeLinkMenu();
    }
  };

  scrollListenerForSecondaryMenuUnification = (event) => {
    {
      const header = document.querySelector(`.${DESKTOP_HEADER_BASE_CLASS_NAME}`);
      if (!header) {
        return;
      }

      let scrolledUpEnough = false;

      if (document.scrollingElement.scrollTop > this._scrollInfo.prevScrollTop) {
        //scrolling down
        this._scrollInfo.scrollingDown = true;
      } else {
        //scrolling up
        if (this._scrollInfo.scrollingDown) {
          this._scrollInfo.scrollTopWhenStartedScrollingUp = document.scrollingElement.scrollTop;
        }
        scrolledUpEnough =
          this._scrollInfo.scrollTopWhenStartedScrollingUp - document.scrollingElement.scrollTop >
          HeaderConstants.SCROLL_BACK_UP_THRESHOLD;

        this._scrollInfo.scrollingDown = false;
      }

      this._scrollInfo.prevScrollTop = document.scrollingElement.scrollTop;

      const showUnifiedBanner =
        document.scrollingElement.scrollTop > HeaderConstants.SCROLL_PIXEL_THRESHOLD &&
        (this._scrollInfo.scrollingDown || !scrolledUpEnough);

      if (document.scrollingElement.scrollTop > 0) {
        //shows the bottom menu border after scroll start
        header.classList.add("scroll-started");
      } else {
        header.classList.remove("scroll-started");
      }

      if (showUnifiedBanner) {
        header.classList.add("scrolled-threshold");
      } else {
        header.classList.remove("scrolled-threshold");
      }
    }
  };

  openLinkMenu(menuId) {
    const { supportHover } = this.props;
    if (!supportHover) {
      window.addEventListener("mousedown", this.handleClickOutsideMenu);
    }
    this.setState({
      openedMenuId: menuId
    });
    BigBrain("track", HEADER_SUBMENU_OPENED, { kind: menuId });

    this._basicHeader.forceShadow();
  }

  closeLinkMenu = (e) => {
    const { supportHover } = this.props;
    if (
      supportHover &&
      e?.relatedTarget?.closest &&
      e.relatedTarget.closest(`.${HeaderConstants.HEADER_MENU_COMPONENT_WRAPPER_CLASS_NAME}`)
    )
      return;

    const { openedMenuId } = this.state;
    if (!openedMenuId) return;

    if (!supportHover) {
      this.removeClickOutsideEvent();
    }

    this.setState({
      openedMenuId: null
    });

    BigBrain("track", HEADER_SUBMENU_CLOSED, { kind: openedMenuId });
    this._basicHeader.unforceShadow();
  };

  getButtonConfig() {
    const { buttonConfig } = this.props;
    const { buttonType } = buttonConfig;

    let extraConfigs;

    switch (buttonType) {
      case SIGNUP_BUTTON_TYPE: {
        extraConfigs = { buttonSize: "xs" };
        break;
      }

      default: {
        extraConfigs = {};
        break;
      }
    }

    return { ...buttonConfig, ...extraConfigs };
  }

  getUnifiedDesktopLogoIfExists = () => {
    const { isSecondaryMenuNeeded } = this.props;
    if (!isSecondaryMenuNeeded) return null;
    const { pageClusterConfig, useProductMiniSiteConfig } = this.props;
    return getMiniSiteUnifiedDesktopLogo(pageClusterConfig, { useProductMiniSiteConfig });
  };

  renderSubmenuWithTransitionIfNeeded = (menuId) => {
    const { openedMenuId } = this.state;

    //always render transition - menu rendered only if open
    const isMenuOpen = openedMenuId === menuId;

    return (
      <CSSTransitionGroup
        transitionName="submenu"
        transitionEnterTimeout={HeaderConstants.HEADER_MENU_TRANSITION_DURATION}
        transitionLeaveTimeout={HeaderConstants.HEADER_MENU_TRANSITION_DURATION}
      >
        {isMenuOpen && this.renderMainHeaderPopup(menuId)}
      </CSSTransitionGroup>
    );
  };

  shouldShowMainPricingLink = () => {
    const { isSecondaryMenuNeeded, pageClusterConfig, useProductMiniSiteConfig } = this.props;

    if (!isSecondaryMenuNeeded) return true;
    return !shouldHideGeneralPricingInMinisite(pageClusterConfig, { useProductMiniSiteConfig });
  };

  shouldShowMainTemplateCenterLink = () => {
    const { isSecondaryMenuNeeded, pageClusterConfig, useProductMiniSiteConfig } = this.props;

    if (!isSecondaryMenuNeeded) return true;
    return !shouldHideGeneralTemplatesInMinisite(pageClusterConfig, { useProductMiniSiteConfig });
  };

  renderBaseHeaderLeftLinks = () => {
    const { openedMenuId } = this.state;
    const { isSecondaryMenuNeeded, supportHover } = this.props;

    return (
      <>
        <div className="link-item-with-menu-component-wrapper" role="listitem">
          <LinkItemWithMenuComponent
            title="header.product"
            openMenu={this.openProductMenu}
            closeMenu={this.closeLinkMenu}
            isOpen={openedMenuId === PRODUCT_MENU_ID}
            shouldDelayMenuOpenOnHover={isSecondaryMenuNeeded}
            supportHover={supportHover}
          />
        </div>
        {this.renderSubmenuWithTransitionIfNeeded(PRODUCT_MENU_ID)}

        <div className="link-item-with-menu-component-wrapper" role="listitem">
          <LinkItemWithMenuComponent
            title={"header.solutions"}
            openMenu={this.openUseCasesMenu}
            closeMenu={this.closeLinkMenu}
            isOpen={openedMenuId === USE_CASES_MENU_ID}
            shouldDelayMenuOpenOnHover={isSecondaryMenuNeeded}
            supportHover={supportHover}
          />
        </div>
        {this.renderSubmenuWithTransitionIfNeeded(USE_CASES_MENU_ID)}

        {this.shouldShowMainTemplateCenterLink() && (
          <div className="link-item-component-wrapper" role="listitem">
            <LinkItemComponent title="header.templates" url={TEMPLATE_CENTER_PAGE_LINK} />
          </div>
        )}

        {this.shouldShowMainPricingLink() && (
          <div className="link-item-component-wrapper">
            <LinkItemComponent title="header.pricing" url={PRICING_PAGE_LINK} />
          </div>
        )}
      </>
    );
  };

  renderUnifiedLinks = () => {
    const { pageClusterConfig, useProductMiniSiteConfig } = this.props;
    const links = getMiniSiteLinks(pageClusterConfig, { onlyUnifiedLinks: true, useProductMiniSiteConfig });

    if (this.shouldShowMainTemplateCenterLink()) {
      links.push({ text: "header.templates", url: TEMPLATE_CENTER_PAGE_LINK });
    }

    if (this.shouldShowMainPricingLink()) {
      links.push({ text: "header.pricing", url: PRICING_PAGE_LINK });
    }

    return links.map((link) => (
      <div className="link-item-component-wrapper" key={link?.text}>
        <LinkItemComponent title={link?.text} url={link?.url} />
      </div>
    ));
  };

  shouldSeeConsultWithUsMenuItem = () => {
    const { abTests, localeId } = this.props;
    return (!localeId || localeId === ENGLISH_LOCALE_ID) && shouldSeeConsultWithUsAbTest(abTests, true);
  };

  renderBaseHeader = () => {
    const { abTests, showMenu, showButton, universeHeader, isSecondaryMenuNeeded } = this.props;

    // if universe header prop is 'yes' or the menu is not shown, don't enter the test
    if (!universeHeader && showMenu && !shouldRenderUniverseHeaderABTest(abTests, true)) return this.renderMainHeader();

    const { openedMenuId } = this.state;
    const universeHeaderProps = {
      showMenu,
      shouldSeeConsultWithUs: this.shouldSeeConsultWithUsMenuItem(),
      showButton,
      buttonConfig: this.getButtonConfig(),
      openedMenuId,
      openLinkMenu: this.openLinkMenu.bind(this),
      closeLinkMenu: this.closeLinkMenu.bind(this),
      shouldShowMainPricingLink: this.shouldShowMainPricingLink.bind(this),
      isSecondaryMenuNeeded,
      renderUnifiedLinks: this.renderUnifiedLinks.bind(this),
      openSignupPopup: this.openSignupPopup.bind(this)
    };

    return <UniverseHeader {...universeHeaderProps} />;
  };

  openSignupPopup = () => {
    this.setState({ showSignupPopup: true });
  };

  closeSignupPopup = () => {
    this.setState({ showSignupPopup: false });
  };

  renderMainHeader = () => {
    const { showMenu, showButton, showLanguagePicker, isSecondaryMenuNeeded } = this.props;
    const buttonConfig = this.getButtonConfig();
    const shouldSeeConsultWithUs = this.shouldSeeConsultWithUsMenuItem();

    return (
      <nav aria-label="Main" className="base-header-desktop-content">
        {showMenu && (
          <div className="left-side-header-links">
            <div className="absolute-main-links" role="list">
              {this.renderBaseHeaderLeftLinks()}
            </div>
            {isSecondaryMenuNeeded && <div className="absolute-unified-links">{this.renderUnifiedLinks()}</div>}
          </div>
        )}

        {showMenu && (
          <div className="right-side-header-links">
            {showLanguagePicker && (
              <div className={classnames("link-item-component-wrapper", "header-language-picker")}>
                <LanguagePickerComponent dialogDirection={DIALOG_DIRECTIONS.ALIGN_BOTTOM} showLabel={false} />
              </div>
            )}

            <div className="link-item-component-wrapper">
              <LinkItemComponent title="header.contactSales" url={CONTACT_US_FROM_HEADER_PAGE_LINK} />
            </div>

            {shouldSeeConsultWithUs && (
              <div className="link-item-component-wrapper">
                <LinkItemComponent title="header.consultWithUs" url={CONSULT_WITH_US_FROM_HEADER_PAGE_LINK} />
              </div>
            )}

            <div className="link-item-component-wrapper">
              <LinkItemComponent title="header.logIn" url={LOGIN_PAGE_LINK} />
            </div>
          </div>
        )}

        {showButton && (
          <div className="header-button-wrapper">
            <Button
              {...buttonConfig}
              parentSegment={HeaderConstants.DESKTOP_HEADER_SEGMENT_NAME}
              onButtonClick={this.openSignupPopup}
            />
          </div>
        )}
      </nav>
    );
  };

  renderMainHeaderPopup = (openedMenuId) => {
    const { supportHover } = this.props;
    const MenuItems = SectionsHeadersMenuItemsMapping;

    const headerMenuItems = MenuItems[openedMenuId];
    const MenuComponent = HeaderMenus[SectionsLinkWithMenuMenuComponentMapping[openedMenuId]];

    const closeOnMouseLeaveEvent = supportHover ? { onMouseLeave: this.closeLinkMenu } : null;

    return (
      <div
        className={HeaderConstants.HEADER_MENU_COMPONENT_WRAPPER_CLASS_NAME}
        key={openedMenuId}
        {...closeOnMouseLeaveEvent}
      >
        <nav aria-label="main submenu" className="menu-component-wrapper">
          {MenuComponent && <MenuComponent menuItems={headerMenuItems} />}
        </nav>
      </div>
    );
  };

  getMainPageLogo = () => {
    const { pageClusterConfig, logoHref, logoSrc, isSecondaryMenuNeeded, useProductMiniSiteConfig } = this.props;
    if (pageClusterConfig && !isSecondaryMenuNeeded) {
      const clusterMainLogo = getClusterDesktopLogo(pageClusterConfig, { useProductMiniSiteConfig });
      if (clusterMainLogo)
        return { logoHref: clusterMainLogo.url, logoSrc: clusterMainLogo.src, logoAltText: clusterMainLogo.alt };
    }
    return { logoHref, logoSrc };
  };

  render() {
    const { isSecondaryMenuNeeded, logoPopup, translate } = this.props;
    const { openedMenuId, showSignupPopup } = this.state;

    const unifiedDesktopLogo = this.getUnifiedDesktopLogoIfExists();

    const mainLogo = this.getMainPageLogo();

    return (
      <header className={DESKTOP_HEADER_BASE_CLASS_NAME} ref={this._headerRef}>
        <BasicHeaderComponent
          ref={(element) => (this._basicHeader = element)}
          imageHref={mainLogo.logoHref}
          imageSrc={mainLogo.logoSrc}
          imageAlt={mainLogo.logoAltText}
          secondaryLogoObject={unifiedDesktopLogo}
          logoPopup={logoPopup}
          isMenuOpen={!!openedMenuId}
        >
          {this.renderBaseHeader()}
        </BasicHeaderComponent>

        {isSecondaryMenuNeeded && (
          <div className="secondary-header-wrapper">
            <SecondaryHeaderDesktopComponent />
          </div>
        )}

        {showSignupPopup && (
          <div className="signup-popup-wrapper">
            <SignupPopupScreenComponent translate={translate} closePopupAction={this.closeSignupPopup} />
          </div>
        )}

        <style jsx>{componentStyles}</style>
      </header>
    );
  }
}

BaseHeaderDesktopComponent.defaultProps = {
  showMenu: true,
  showButton: true,
  supportHover: false
};

export default withGenericConfig(withAbTests(BaseHeaderDesktopComponent));
